
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function CrusadesPage() {
  const upcomingCrusades = [
    {
      title: 'Christ Gospel Crusade 2025',
      location: 'Sagamu, Nigeria',
      date: 'November 17 - 22, 2025',
      theme: 'From Moses to Messiah: The Fullness of Christ',
      image: 'https://readdy.ai/api/search-image?query=Large%20outdoor%20gospel%20crusade%20in%20Africa%2C%20massive%20crowd%20gathering%2C%20stage%20with%20speakers%2C%20evening%20lighting%2C%20spiritual%20atmosphere%2C%20evangelistic%20event%20context&width=400&height=300&seq=crusade1&orientation=landscape'
    },
    {
      title: 'Global Simultaneous Crusade',
      location: 'Multiple Cities Worldwide',
      date: 'March 2025',
      theme: 'One Message, One Banner, One Christ',
      image: 'https://readdy.ai/api/search-image?query=Multiple%20simultaneous%20gospel%20crusades%20around%20the%20world%2C%20global%20unity%20concept%2C%20diverse%20crowds%2C%20simple%20background%2C%20warm%20lighting%2C%20worldwide%20evangelism%20context&width=400&height=300&seq=crusade2&orientation=landscape'
    }
  ];

  const pastCrusades = [
    {
      year: '2023',
      location: 'Abuja, Nigeria',
      attendance: '250,000+',
      salvations: '15,000+',
      healings: '5,000+'
    },
    {
      year: '2022',
      location: 'Accra, Ghana',
      attendance: '180,000+',
      salvations: '12,000+',
      healings: '3,500+'
    },
    {
      year: '2021',
      location: 'Nairobi, Kenya',
      attendance: '200,000+',
      salvations: '18,000+',
      healings: '4,200+'
    }
  ];

  const features = [
    {
      title: 'Global Evangelism',
      description: 'Reaching millions with the Gospel through coordinated worldwide campaigns',
      icon: 'ri-earth-line'
    },
    {
      title: 'Mass Crusades',
      description: 'Large-scale evangelistic gatherings in major cities across continents',
      icon: 'ri-group-line'
    },
    {
      title: 'Unified Campaigns',
      description: 'Simultaneous crusades under one message and banner worldwide',
      icon: 'ri-flag-line'
    },
    {
      title: 'Soul Winning',
      description: 'Focused on bringing the lost into the Kingdom of God',
      icon: 'ri-heart-add-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(184, 20, 74, 0.8), rgba(184, 20, 74, 0.8)), url('https://readdy.ai/api/search-image?query=Massive%20gospel%20crusade%20with%20thousands%20of%20people%2C%20outdoor%20stadium%20setting%2C%20powerful%20stage%20lighting%2C%20evening%20atmosphere%2C%20spiritual%20revival%20context%2C%20evangelistic%20gathering&width=1920&height=800&seq=crusadehero&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl font-bold mb-6">Christ Gospel Crusade</h1>
          <p className="text-xl max-w-4xl mx-auto mb-8">
            Annual, simultaneous global evangelistic campaigns under one message and one banner
          </p>
          <Link 
            to="/join"
            className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Join the Crusade
          </Link>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Global Evangelistic Impact</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Christ Gospel Crusade represents the evangelistic arm of PAAM, conducting massive 
              soul-winning campaigns that transform cities and nations.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${feature.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-700">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Upcoming Crusades */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Upcoming Crusades</h2>
            <p className="text-xl text-gray-600">Join us for these life-changing evangelistic events</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {upcomingCrusades.map((crusade, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <img 
                  src={crusade.image}
                  alt={crusade.title}
                  className="w-full h-64 object-cover"
                />
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{crusade.title}</h3>
                  <div className="space-y-3 mb-6">
                    <div className="flex items-center text-gray-700">
                      <i className="ri-map-pin-line text-[#b8144a] mr-3"></i>
                      <span>{crusade.location}</span>
                    </div>
                    <div className="flex items-center text-gray-700">
                      <i className="ri-calendar-line text-[#b8144a] mr-3"></i>
                      <span>{crusade.date}</span>
                    </div>
                    <div className="flex items-center text-gray-700">
                      <i className="ri-bookmark-line text-[#b8144a] mr-3"></i>
                      <span className="font-semibold">{crusade.theme}</span>
                    </div>
                  </div>
                  <Link 
                    to="/join"
                    className="bg-[#b8144a] hover:bg-[#a01240] text-white px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Register Now
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Past Crusades Impact */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Crusade Impact</h2>
            <p className="text-xl text-gray-600">Testimonies of God's power in past crusades</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {pastCrusades.map((crusade, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-lg shadow-lg text-center">
                <h3 className="text-3xl font-bold text-[#b8144a] mb-2">{crusade.year}</h3>
                <h4 className="text-xl font-semibold text-gray-900 mb-6">{crusade.location}</h4>
                <div className="space-y-4">
                  <div>
                    <p className="text-2xl font-bold text-gray-900">{crusade.attendance}</p>
                    <p className="text-gray-600">Total Attendance</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-green-600">{crusade.salvations}</p>
                    <p className="text-gray-600">Souls Saved</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-blue-600">{crusade.healings}</p>
                    <p className="text-gray-600">Miraculous Healings</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Crusade Vision */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">The Vision</h2>
              <p className="text-lg text-gray-700 mb-6">
                Christ Gospel Crusade exists to fulfill the Great Commission through massive evangelistic 
                campaigns that demonstrate the power of God and bring multitudes into the Kingdom.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] text-lg mt-1"></i>
                  <span className="text-gray-700">Simultaneous crusades across multiple continents</span>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] text-lg mt-1"></i>
                  <span className="text-gray-700">Unified apostolic message and banner</span>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] text-lg mt-1"></i>
                  <span className="text-gray-700">Signs, wonders, and miraculous healings</span>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-check-line text-[#b8144a] text-lg mt-1"></i>
                  <span className="text-gray-700">Mass salvation and spiritual awakening</span>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Apostle%20preaching%20at%20massive%20outdoor%20crusade%2C%20powerful%20ministry%20moment%2C%20crowd%20responding%2C%20evening%20lighting%2C%20spiritual%20atmosphere%2C%20evangelistic%20context&width=600&height=400&seq=crusadevision&orientation=landscape"
                alt="Crusade Vision"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Partnership Opportunities */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Partner With Us</h2>
            <p className="text-xl text-gray-600">Join the global evangelistic movement</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-megaphone-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Evangelist</h3>
              <p className="text-gray-700 mb-6">
                Join our evangelistic team and help preach the Gospel to the nations.
              </p>
              <Link 
                to="/join"
                className="text-[#b8144a] hover:text-[#a01240] font-semibold cursor-pointer"
              >
                Apply Now →
              </Link>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-heart-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Sponsor</h3>
              <p className="text-gray-700 mb-6">
                Support crusades financially and help reach millions with the Gospel.
              </p>
              <Link 
                to="/join"
                className="text-[#b8144a] hover:text-[#a01240] font-semibold cursor-pointer"
              >
                Partner With Us →
              </Link>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-user-heart-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Volunteer</h3>
              <p className="text-gray-700 mb-6">
                Serve in crusade organization, logistics, and follow-up ministries.
              </p>
              <Link 
                to="/join"
                className="text-[#b8144a] hover:text-[#a01240] font-semibold cursor-pointer"
              >
                Volunteer Today →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">The Harvest is Ready</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Join Christ Gospel Crusade and become part of the greatest evangelistic movement 
            of our time. The nations are waiting for the Gospel.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/join"
              className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Join the Crusade
            </Link>
            <Link 
              to="/training"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-[#b8144a] transition-colors whitespace-nowrap cursor-pointer"
            >
              Evangelism Training
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
